import { Outlet } from "react-router";
import { SidebarProvider } from "@/components/ui/sidebar";
import { SidebarLayout, type SidebarMenuGroup } from "@/components/layouts/sidebar-layout";

type Props = {
    menus: SidebarMenuGroup[];
};

export function DashboardLayout({ menus }: Props) {
  return (
    <SidebarProvider>
      <SidebarLayout menus={menus}>
        <Outlet />
      </SidebarLayout>
    </SidebarProvider>
  );
}